import React from 'react';
import { Badge } from 'react-bootstrap';
import {
  getShipmentStatus,
  getShipmentStatusBadgeVariant,
  getShipmentListWarnings,
  isShipmentNotStarted,
} from '../../helper/shipment_tracking_helper';

export default function OrderShipmentStatusChip({ order, compact = false }) {
  if (!order) return <span className="text-muted small">—</span>;

  if (isShipmentNotStarted(order)) {
    return (
      <span className="text-muted small" title="Not shipped yet">
        {compact ? '—' : 'Not shipped'}
      </span>
    );
  }

  const status = getShipmentStatus(order);
  const warnings = getShipmentListWarnings(order);

  return (
    <div className="order-shipment-chip d-flex flex-column align-items-start gap-1">
      {status ? (
        <Badge bg={getShipmentStatusBadgeVariant(status)} className="order-shipment-chip__status">
          {status}
        </Badge>
      ) : (
        <Badge bg="secondary">In transit</Badge>
      )}
      {warnings.length > 0 ? (
        <div className="d-flex flex-wrap gap-1">
          {warnings.map((w) => (
            <Badge
              key={w.code}
              bg={w.code === 'stuck' ? 'warning' : 'danger'}
              text={w.code === 'stuck' ? 'dark' : undefined}
              className="order-shipment-chip__warn"
              title={
                w.code === 'stuck'
                  ? 'No tracking update for 3+ days'
                  : w.code === 'ndr'
                    ? 'Non-delivery reported'
                    : 'Return to origin'
              }
            >
              <i className="ri-error-warning-line me-1" />
              {w.label}
            </Badge>
          ))}
        </div>
      ) : null}
    </div>
  );
}
